import React, { useRef, useState } from "react";
import {
  clearImageryLayers,
  selectOnChange
} from "./DocOverlayVM";
import useDocOverLayHook from "./useDocOverLayHook";
import ChangeOverlayColorWidget from '../doc-overlay/ChangeOverlayColorWidget'
import { Button } from "@mui/material";

const DocOverlayWidget = ({ view, layerIds}) => {
  const [currentValue, setCurrentValue] = useState<any>();
  const docOverLayDiv = useRef(null);
  const payload: any[] = useDocOverLayHook({ view, setCurrentValue,layerIds });

  const optionListJSX = payload.map((value) => {
    if (value) {
      return (
        <option id={value} value={value} key={value}>
          {value}
        </option>
      );
    }
  });

  return (
    <div ref={docOverLayDiv} style={{ display: 'flex', flexDirection: 'column-reverse' }}>
      {payload.length ?
        <>
          <Button variant="contained"color="secondary" title="clear overlay from map" onClick={
            () => {
              setCurrentValue([""])
              view.map.allLayers.forEach(layer => {
                clearImageryLayers(layer)
              })

            }
          }><div className="primary-color-hover">Clear Overlays</div></Button>
            <ChangeOverlayColorWidget view={view} layerIds={layerIds}></ChangeOverlayColorWidget>
          <select className="selectOverlays"
            value={currentValue}
            multiple={true}
            onChange={(e) => selectOnChange(view, e, setCurrentValue)}
            style={{ marginBottom: '1rem' }}
          >
            {optionListJSX}
          </select></> :
        <div style={{ fontSize: '16px' }}>No Available Overlay</div>}
    </div>
  );
};

export default DocOverlayWidget;
